import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { BaseFormComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-form.component";
import { SelectorService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/selector.service";
import { InvDailyRemain } from "../../model/inv-daily-remain.model";
import { Branch, form_control } from "projects/sepidz-web-framework/src/lib/models";
import * as moment from "moment";
import { FormContainerModel } from "projects/sepidz-web-framework-shell/src/lib/tabular/form-container-model";
import { TabularService } from "projects/sepidz-web-framework-shell/src/lib/tabular/tabular.service ";
import { Datatransfer } from "projects/sepidz-web-framework/src/lib/models/datatransfer.model";
import { take } from "rxjs/operators";
import { SplashFormService } from "projects/sepidz-web-framework-shell/src/lib/shared/splash-form/Splash-form.service";
import { FormGroup } from "@angular/forms";
import { PagingDataResult, Utilities } from "projects/sepidz-web-framework/src/lib/services";
import { RowState } from "projects/sepidz-web-framework/src/lib/models/enums";

@Component({
  selector: "ngx-inv-daily-remain-form",
  templateUrl: "./inv-daily-remain-form.component.html",
  styleUrls: ["./inv-daily-remain-form.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InvDailyRemainFormComponent extends BaseFormComponent<InvDailyRemain> {
  itemColumns: form_control[];
  DateNow: string;
  BranchLookUp: Branch[] = [];
  goodsList: any[];
  constructor(
    protected selectorService: SelectorService,
    protected cd: ChangeDetectorRef,
    __id: FormContainerModel,
    private _tabsservice: TabularService,
    private splashFormService: SplashFormService,
    private datatransfer: Datatransfer
  ) {
    super(selectorService, cd);
    this._id = __id;
    this.tabsservice = _tabsservice;
    this.currentrow = this.datatransfer?.currentrow;
  }
  async ngOnInit() {
    this.apiName = "InvDailyRemain";
    this.label = this.translate("ClientApp.Pages.PageMenu.InvDailyRemain");
    super.ngOnInit();
    const m = moment();
    this.DateNow = m.locale("fa").subtract(1, "days").format("YYYY/MM/DD");
    await this.FillData();
  }

  async FillData() {
    const data = await (<Promise<Branch[]>>this.httpCommonService.getList("Branch").pipe(take(1)).toPromise());
    if (this.isMultiBranch) this.BranchLookUp = data.filter((x) => !x.AccessToAllBranches && x.IsActive);
    else this.BranchLookUp = data.filter((x) => x.Id == this.accountService.authService.currentBranchId);
    if (this.isMultiBranch) {
      this.httpCommonService
        .get("Item/ReadInvDailyGoodsLookUpPaging")
        .pipe(take(1))
        .subscribe((res: PagingDataResult<any>) => {
          this.goodsList = res.Data;
          this.selectorService.setDataList("GoodsId", this.goodsList);
        });
    }
  }

  setdefault(): void {
    if (!this.model.InvDailyRemainDetaillList) this.model.InvDailyRemainDetaillList = [];
    if (!this.model.VoucherDate) this.model.VoucherDate = this.DateNow as any;
    if (!this.model.FiscalYearId) this.model.FiscalYearId = this.accountService.authService.currentFiscalYear?.Id;
    if (!this.isMultiBranch) this.model.BranchId = this.accountService.authService.currentBranch?.Id;
  }

  isValid() {
    if (!this.model.InvDailyRemainDetaillList.filter((x) => x.State !== RowState.Detached && x.State !== RowState.Delete).length) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Inv.DailyRemain.EnterRequiredMinimizeItem"),
        this.translate("ClientApp.FrontOffice.Inv.DailyRemain.Attention")
      );
      return false;
    }
    if (this.model.InvDailyRemainDetaillList.filter((x) => x.State !== RowState.Detached && x.State !== RowState.Delete).find((x) => x.Remain <= 0)) {
      this.sts.showDialog(
        this.translate("ClientApp.FrontOffice.Inv.DailyRemain.InSomeRowsValueZeroOrNegative"),
        this.translate("ClientApp.FrontOffice.Inv.DailyRemain.Attention")
      );
      return false;
    }
    if (!this.formGroup.controls["VoucherDate"].value) {
      this.sts.showToast(
        "danger",
        this.translate("ClientApp.FrontOffice.Inv.DailyRemain.Attention"),
        this.translate("ClientApp.FrontOffice.Inv.DailyRemain.DateNotEntered")
      );
      return false;
    }
    return super.isValid();
  }
  addControl(): void {
    this.setValue("InvVoucherHeaderId", this.model.InvVoucherHeaderId);
    this.setValue("BranchId", this.model.BranchId);
    this.setValue("BranchCode", this.model.BranchCode);
    this.setValue("BranchTitle", this.model.BranchTitle);
    this.setValue("WarehouseId", this.model.WarehouseId);
    this.setValue("FiscalYearId", this.model.FiscalYearId);
    this.setValue("Year", this.model.Year);
    this.setValue("VoucherDate", this.model.VoucherDate);
    this.setValue("ShamsiVoucherDate", this.model.ShamsiVoucherDate);
    this.setValue("Description", this.model.Description);
    if (!this.isMultiBranch || (this.isMultiBranch && this.currentrow)) this.formGroup.controls["BranchId"].disable();
  }

  setColumnAttribute(): void {
    super.setColumnAttribute();
    this.selectorService.setTakeValue("GoodsId", 1000);
    this.itemColumns = this.getDetailControlModels("InvDailyRemainDetaillList");
    const goodsIdControl = this.itemColumns.find((x) => x.name === "GoodsId");
    const goodsTitleControl = this.itemColumns.find((x) => x.name === "GoodsTitle");
    if (goodsIdControl && !goodsIdControl["custom"]) {
      goodsIdControl.name = "GoodsTitle";
      goodsIdControl["custom"] = true;
    }
    if (goodsTitleControl && !goodsTitleControl["custom"]) {
      goodsTitleControl.name = "GoodsId";
      goodsTitleControl["custom"] = true;
    }
  }

  onGridValueChanges(changedData: { newValue: any; oldValue: any; field: string; formGroup: FormGroup }): void {
    if (changedData.field === "RemainAmount" || changedData.field === "BalanceAmount") {
      const values = changedData.formGroup.getRawValue();
      changedData.formGroup.controls["Remain"].setValue(values.RemainAmount + values.BalanceAmount);
    }
  }

  beforupdate() {
    this.model.InvDailyRemainDetaillList = this.model.InvDailyRemainDetaillList?.filter((x) => x.State !== RowState.Detached);
    this.model.InvDailyRemainDetaillList.forEach((x) => {
      if (!x.InvDailyRemainId) x.InvDailyRemainId = this.model.Id;
    });
  }

  loadItems() {
    const controls = this.formGroup.controls;
    if (controls["VoucherDate"].value && controls["BranchId"].value) {
      this.splashFormService.openDialog("", this.translate("ClientApp.FrontOffice.Inv.DailyRemain.GettingInformation"));
      this.httpCommonService
        .get(`InvDailyRemain/GetInvRemainItems?date=${controls["VoucherDate"].value.toISOString()}&branchId=${controls["BranchId"].value}`)
        .pipe(take(1))
        .subscribe(
          (data: any) => {
            this.model.InvDailyRemainDetaillList = data;
            this.splashFormService.closeLoading();
            this.cd.markForCheck();
          },
          (err) => {
            let message = Utilities.getHttpResponseMessage(err);
            this.sts.showDialog(`${message}`, this.translate("ClientApp.FrontOffice.Inv.DailyRemain.ErrorMessage"));
            this.splashFormService.closeLoading();
          }
        );
    }
  }

  removeEmptyValues() {
    this.model.InvDailyRemainDetaillList = this.model.InvDailyRemainDetaillList.filter((x) => x.RemainAmount !== 0);
    this.cd.markForCheck();
  }

  protected isCloseable(): boolean {
    this.selectorService.submitted$.next(false);
    this.formGroup?.markAsUntouched();
    return true;
  }

  onBranchChanges(branch: any) {
    if (this.isMultiBranch && branch) {
      const BranchId = branch.Id;
      const list = this.goodsList.filter((x) => x.BranchId == BranchId || !x.branchId);
      const goodsWithBranchZero = list.filter((g) => g.BranchId === 0);
      const goodsToRemove: any[] = [];

      goodsWithBranchZero.forEach((good) => {
        const equivalentGood = list.find((g) => g.Id === good.Id && g.BranchId !== 0);
        if (equivalentGood) goodsToRemove.push(good);
      });

      goodsToRemove.forEach((goodToRemove) => {
        const index = list.findIndex((g) => g.Id === goodToRemove.Id);
        if (index !== -1) {
          goodsToRemove.splice(index, 1);
        }
      });
      this.selectorService.setDataList("GoodsId", list);
    }
  }

  onRowSelected() {
    if (this.isMultiBranch) {
      if (!this.formGroup.controls["BranchId"].value) {
        this.sts.showDialog(this.translate("ClientApp.FrontOffice.Inv.DailyRemain.SelectDesiredBranchFirst"), "");
      } else this.formGroup.controls["BranchId"].disable();
    }
  }
  afterDeleted() {
    if (
      !this.isMultiBranch &&
      !this.model.InvDailyRemainDetaillList.filter((x) => x.State !== RowState.Detached && x.State !== RowState.Delete).length
    ) {
      this.formGroup.controls["BranchId"].enable();
    }
  }

  ngOnDestroy(): void {
    this.selectorService.dataList["GoodsId"] = null;
    delete this.selectorService.dataList["GoodsId"];
    super.ngOnDestroy();
  }
}
